import { cloneElement } from 'react';
import { classes } from '../../../utils/commonUtils';
import css from './details-spacing.module.scss';

interface DetailsSpacingProps {
  children: JSX.Element;
  type?: 'padding' | 'margin';
}

/**
 * Clones the child element and adds padding to it via a `className`.
 * Can only be used directly on HTML elements. If you want to use it on a custom component,
 * you need to forward the `className` prop to the root element of the component.
 */
export function DetailsSpacing({ children, type = 'margin' }: DetailsSpacingProps) {
  return cloneElement(children, {
    className: classes(children.props.className, css[type]),
  });
}
